export const build = <T extends string>(_name: T): undefined => undefined
